var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/ActionBarHeader.tsx";
import React from 'react';
import { Divider, HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack } from '@adc/parallax-icons';
import { usePartner } from 'Hooks';
import { IconButton } from 'Components/utility';
import { ANALYTICS_ACTIONS, ANALYTICS_EVENTS, ANALYTICS_MODULE_TYPES } from 'Constants/analytics';
import * as analyticsManager from 'Utilities/analytics/analyticsManager';
import i18n from 'Utilities/i18n';
const ActionBarHeader = ({
  testID
}) => {
  const {
    partner
  } = usePartner();
  if (!partner) {
    return null;
  }
  return /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    padding: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    testID: `${testID}.action-back-btn`,
    marginRight: "$2",
    onPress: () => {
      analyticsManager.track(ANALYTICS_EVENTS.CONNECTION_MANAGED, {
        module: ANALYTICS_MODULE_TYPES.CONAPPS_MODULE,
        action: ANALYTICS_ACTIONS.ABANDON
      });
      window.location.replace(partner.website);
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconBack, {
    testID: `${testID}.action-back-btn-icon`,
    size: "XS",
    color: "$interactive.tertiary.enabled.onColor",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Text, {
    testID: `${testID}.action-back-btn-text`,
    fontSize: "$bodySmall.default",
    color: "$interactive.tertiary.enabled.onColor",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }, i18n.t('Login.content.returnPartnerHeader.bodyText', {
    partnerName: partner.displayName
  }))), /*#__PURE__*/React.createElement(Divider, {
    marginTop: "$2",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }));
};
export { ActionBarHeader };